module.exports = __webpack_public_path__ + "static/media/bff5.357090a6.png";